var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "resportesserie" },
    [
      _c(
        "div",
        [
          _c(
            "FormFieldsContainer",
            { on: { resultadoBusqueda: _vm.filtroRequerimiento } },
            [
              _c(
                "v-flex",
                { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { sm4: "", md4: "" } },
                    [
                      _c("v-text-field", {
                        staticStyle: { "margin-right": "5px" },
                        attrs: {
                          label: "Buscar...",
                          "append-icon": "search",
                          clearable: ""
                        },
                        on: { input: _vm.searchData },
                        model: {
                          value: _vm.filtrobusquedagrilla,
                          callback: function($$v) {
                            _vm.filtrobusquedagrilla = $$v
                          },
                          expression: "filtrobusquedagrilla"
                        }
                      })
                    ],
                    1
                  ),
                  _c("v-flex", { attrs: { sm6: "", md6: "", align: "rigth" } }),
                  _c(
                    "v-flex",
                    { attrs: { sm2: "", md2: "", align: "rigth" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { flat: "", small: "", color: "primary" },
                          on: { click: _vm.exportarExcel }
                        },
                        [
                          _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                            _vm._v("cloud_download")
                          ]),
                          _c("span", { staticClass: "importExportBtnTexto" }, [
                            _vm._v("Exportar"),
                            _c("br"),
                            _vm._v("CSV")
                          ])
                        ],
                        1
                      ),
                      _c(
                        "v-btn",
                        {
                          staticStyle: {
                            "padding-right": "20px",
                            margin: "0 0 0 auto",
                            "margin-top": "15px"
                          },
                          attrs: { color: "#ffe800" },
                          on: { click: _vm.crear_estado }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticStyle: { color: "black" },
                              attrs: { dark: "", left: "" }
                            },
                            [_vm._v("add_circle_outline")]
                          ),
                          _c("span", { staticStyle: { color: "black" } }, [
                            _vm._v("Crear")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("div", {
                staticClass: "clearfix",
                staticStyle: { width: "100%" }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "gridcard rounded-card" },
        [
          _c("MantenedorGridSinCodigo", {
            attrs: {
              "grid-options": _vm.gridOptions,
              "funcionalidad-id": _vm.funcionalidad
            }
          })
        ],
        1
      ),
      _vm.mostrarModalVerDetalle
        ? _c("VerEditarRutaModal", {
            attrs: {
              telcoid: _vm.telcoid,
              telconame: _vm.telconame,
              telcoprefix: _vm.telcoprefix,
              usuarioID: _vm.usuarioID,
              estadoSelected: _vm.estadoSelected
            },
            on: { cerrar: _vm.handleCierreModalVerDetalle }
          })
        : _vm._e(),
      _vm.mostrarModalCrear
        ? _c("VerCrearRutaModal", {
            attrs: { telcoid_crear: _vm.telcoid_crear },
            on: { cerrar: _vm.handleCierreModalCrear }
          })
        : _vm._e(),
      _vm.mostrarModalHistorial
        ? _c("ModalVerHistorial", {
            attrs: { telcoid: _vm.telcoid, telconame: _vm.telconame },
            on: { cerrar: _vm.handleCierreModalCrear }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }